export function attachmentExtension(displayName: string): string {
    const lastDot = displayName.lastIndexOf('.');
    return lastDot <= 0 ? '' : displayName.slice(lastDot + 1);
}
